import React from 'react';
import { ArrowRight } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq?: (action: string, event: string, params?: Record<string, any>) => void;
  }
}
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  className?: string;
  href?: string;
  trackLead?: boolean;
}
export function CTAButton({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  href,
  trackLead = false,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium rounded-full transition-all duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer no-underline';
  const variants = {
    primary: 'bg-rose-500 text-white hover:bg-rose-600 hover:shadow-lg hover:shadow-rose-200 focus:ring-rose-500',
    secondary: 'bg-white text-rose-600 border-2 border-rose-100 hover:border-rose-200 hover:bg-rose-50 focus:ring-rose-200',
    outline: 'bg-transparent border-2 border-rose-500 text-rose-600 hover:bg-rose-50 focus:ring-rose-500'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent) => {
    // Only track if trackLead is true AND the href points to the cart
    const isCartLink = href && href.includes('arisalabs.com/cart');
    if (trackLead && isCartLink && typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead');
    }
  };
  if (href) {
    return <a href={href} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} data-id="element-1">
        {children}
        <ArrowRight className="ml-2 w-5 h-5" data-id="element-2" />
      </a>;
  }
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={e => {
    handleClick(e);
    props.onClick?.(e);
  }} {...props} data-id="element-3">
      {children}
      <ArrowRight className="ml-2 w-5 h-5" data-id="element-4" />
    </button>;
}